/*
 * @Author: your name
 * @Date: 2021-01-13 17:39:02
 * @LastEditTime: 2021-01-18 15:48:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\router\mainRoutes.js
 */
export default {
        path: "/",
        name: "AppMain",
        component: () => import(/* @vite-ignore */ "@/views/AppMain.vue"),
        redirect: { name: "Home" },
        children: [
            {
                path: "home",
                name: "Home",
                component: () => import(/* @vite-ignore */ "@/views/Home.vue"),
            },
            {
                path: "gardenTree",
                name: "GardenTree",
                component: () => import("@/views/layoutpages/garden_tree/Index.vue"),
            }
            ,
            {
                path: "fruits_type_item",
                name: "FruitsTypeItem",
                component: () => import("@/views/layoutpages/fruits_type_item/Index.vue"),
            }
            ,
            {
                path: "warning_param",
                name: "WarningParam",
                component: () => import("@/views/layoutpages/warning_param/Index.vue"),
            }
            ,
            {
                path: "sdd_warning_item",
                name: "SddWarningItem",
                component: () => import("@/views/layoutpages/sdd_warning_item/Index.vue"),
            }

            ,
            {
                path: "area_edit",
                name: "areaEdit",
                component: () => import("@/views/layoutpages/garden/area_edit/Index.vue"),
            }
            ,
            {
                path: "sub_area_edit",
                name: "subAreaEdit",
                component: () => import("@/views/layoutpages/garden/sub_area_edit/Index.vue"),
            },
            {
                path: "distance_view_image_upload",
                name: "distanceViewImageUpload",
                component: () => import("@/views/layoutpages/garden/distance_view_image_upload/index.vue"),
            },
            // 信息化管理
            {
                path: "apic_menu",
                name: "apicMenu",
                component: () => import("@/views/layoutpages/apic_menu/Index.vue"),
            },
            {
                path: "apic_item",
                name: "apicItem",
                component: () => import("@/views/layoutpages/apic_item/Index.vue"),
            },
            {
                path: "container_reproductive",
                name: "ContainerReproductive",
                component: () => import("@/views/layoutpages/container_reproductive/Index.vue"),
            },
            {
                path: "container_reproductive_report_template",
                name: "ContainerReproductiveReportTemplate",
                component: () => import("@/views/layoutpages/container_reproductive/ReportTemplate/Index.vue"),
            },
            {
                path: "container_phenology",
                name: "ContainerPhenology",
                component: () => import("@/views/layoutpages/container_phenology/Index.vue"),
            },
            {
                path: "container_farm_work_arrange",
                name: "ContainerFarmWorkArrange",
                component: () => import("@/views/layoutpages/container_farm_work_arrange/Index.vue"),
            },
            {
                path: "container_farm_work_scheme",
                name: "ContainerFarmWorkScheme",
                component: () => import("@/views/layoutpages/container_farm_work_scheme/Index.vue"),
            },
            {
                path: "container_phenology_sample_files",
                name: "ContainerPhenologySampleFiles",
                component: () => import("@/views/layoutpages/container_phenology_sample_files/Index.vue"),
            },
            {
                path: "container_phenology_farm_files",
                name: "ContainerPhenologyFarmFiles",
                component: () => import("@/views/layoutpages/container_phenology_farm_files/Index.vue"),
            },
            {
                path: "container_phenology_sample_files_speak_title",
                name: "ContainerPhenologySampleFilesSpeakTitle",
                component: () => import("@/views/layoutpages/container_phenology_sample_files_speak_title/Index.vue"),
            },
            {
                path: "container_phenology_sample_files_speak_content",
                name: "ContainerPhenologySampleFilesSpeakContent",
                component: () => import("@/views/layoutpages/container_phenology_sample_files_speak_content/Index.vue"),
            },
            {
                path: "container_phenology_monitor",
                name: "ContainerPhenologyMonitor",
                component: () => import("@/views/layoutpages/container_phenology_monitor/Index.vue"),
            },
            {
                path: "container_phenology_monitor_indicator",
                name: "ContainerPhenologyMonitorIndicator",
                component: () => import("@/views/layoutpages/container_phenology_monitor_indicator/Index.vue"),
            },
            {
                path: "container_phenology_indicator_quest",
                name: "ContainerPhenologyIndicatorQuest",
                component: () => import("@/views/layoutpages/container_phenology_indicator_quest/Index.vue"),
            },
            {
                path: "space_time_detail",
                name: "SpaceTimeDetail",
                component: () => import("@/views/layoutpages/container_space_time/Detail.vue"),
            },
            {
                path: "z_farm_work_lib",
                name: "ZFarmWorkLib",
                component: () => import("@/views/layoutpages/z_farm_work_lib/Index.vue"),
            },
            {
                path: "z_agricultural_store_farm_work",
                name: "ZAgriculturalStoreFarmWork",
                component: () => import("@/views/layoutpages/z_agricultural_store/farm_work/Index.vue"),
            },
            {
                path: "z_agricultural_store_manager",
                name: "ZAgriculturalStoreManager",
                component: () => import("@/views/layoutpages/z_agricultural_store/manager/Index.vue"),
            },
            {
                path: "container_phenology_trigger",
                name: "ContainerPhenologyTrigger",
                component: () => import("@/views/layoutpages/container_phenology/trigger/Index.vue"),
            },
            {
                path: "container_phenology_interaction",
                name: "ContainerPhenologyInteraction",
                component: () => import("@/views/layoutpages/container_phenology/interaction/Index.vue"),
            },
            {
                path: "z_farm_work_lib_prescription",
                name: "ZFarmWorkLibPrescription",
                component: () => import("@/views/layoutpages/z_farm_work_lib_prescription/Index.vue"),
            },
            {
                path: "weather30d",
                name: "Weather30d",
                component: () => import("@/views/layoutpages/weather30d/Index.vue"),
            },
            {
                path: "weather_item_city30",
                name: "WeatherItemCity30",
                component: () => import("@/views/layoutpages/weather_item_city30/Index.vue"),
            },
            {
                path: "container_detail",
                name: "ContainerDetail",
                component: () => import("@/views/layoutpages/container/Detail.vue"),
            },
        ],
    };
